import { FC, useState } from 'react';
import { Owner } from './graphql';
import { PlusSquare } from 'jbc-front/components/icons';
import { useFormContext } from 'react-hook-form';
import { Input } from '../components/form/Input';
import { Panel, Head, Body } from '../components/ui/Panel';
import { FileField } from '../components/react-hook-form/FileField';
import { Schema } from './schema';
import styles from './OwnerFields.scss';

interface Props {
  owner: Owner;
}

export const OwnerFields: FC<Props & { index: number }> = ({ index, owner }) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<Schema>();
  const values = watch(`owners.${index}`);

  const [hasSecondIdImage, setHasSecondIdImage] = useState(false);
  const handler = () => setHasSecondIdImage(true);

  return (
    <div>
      <Panel>
        <Head>{owner.name}さんの情報</Head>
        <Body className={styles.body}>
          <Panel>
            <Head>マイナンバー</Head>
            <Body>
              <Input
                label="マイナンバー"
                {...register(`owners.${index}.myNumber`)}
                error={errors.owners?.[index]?.myNumber?.message}
                isError={!!errors.owners?.[index]?.myNumber?.message}
                required
              />
            </Body>
          </Panel>
          {owner.ownerRequest.requestNumberConfirmation && (
            <Panel>
              <Head>番号確認書類</Head>
              <Body>
                <FileField name={`owners.${index}.myNumberImage`} label="番号確認書類" required>
                  {values.myNumberImage && (
                    <FileField.FileContainer>
                      <FileField.File
                        file={values.myNumberImage}
                        onRemove={() => setValue(`owners.${index}.myNumberImage`, null as unknown as File)}
                      />
                    </FileField.FileContainer>
                  )}
                </FileField>
                <div className={styles.note}>
                  個人番号カード、通知カード、個人番号が記載された住民票の写し、住民票記載事項証明書など
                </div>
              </Body>
            </Panel>
          )}
          {owner.ownerRequest.requestIdentityConfirmation && (
            <Panel>
              <Head>身元確認書類</Head>
              <Body>
                <FileField name={`owners.${index}.idImage0`} label="身元確認書類" required>
                  {values.idImage0 && (
                    <FileField.FileContainer>
                      <FileField.File
                        file={values.idImage0}
                        onRemove={() => setValue(`owners.${index}.idImage0`, null as unknown as File)}
                      />
                    </FileField.FileContainer>
                  )}
                </FileField>
                {!hasSecondIdImage && (
                  <div className="u-ta-r u-mt20 u-mb20">
                    <div role="button" tabIndex={0} onClick={handler} onKeyPress={handler} className="u-txt-addinfo">
                      <PlusSquare size={20} className="u-txt-addinfo-icon" />
                      身元確認書類を追加
                    </div>
                  </div>
                )}
                {hasSecondIdImage && (
                  <div className="u-mt20">
                    <FileField name={`owners.${index}.idImage1`} label="身元確認書類">
                      {values.idImage1 && (
                        <FileField.FileContainer>
                          <FileField.File
                            file={values.idImage1}
                            onRemove={() => setValue(`owners.${index}.idImage1`, null as unknown as File)}
                          />
                        </FileField.FileContainer>
                      )}
                    </FileField>
                  </div>
                )}
                <div className={styles.note}>各種運転免許証、パスポート、在留カード、外国人登録証明書など</div>
              </Body>
            </Panel>
          )}
          <Panel>
            <Head>マイナンバーの利用目的</Head>
            <Body>
              <ul>
                {owner.ownerRequest.purposeOfUseMasters.map((purposeOfUse) => (
                  <li key={purposeOfUse.id} className={styles.purpose}>
                    {purposeOfUse.name}
                  </li>
                ))}
              </ul>
            </Body>
          </Panel>
        </Body>
      </Panel>
    </div>
  );
};
